import React, { Component } from "react";
import { Icon, Menu, Tab } from "semantic-ui-react";
import _ from "lodash";
import SearchFormTemplate from "./SearchFormTemplate";

class SearchForms extends Component {
  state = {
    activeIndex: 0,
  };

  handleTabChange = (e, { activeIndex }) => {
    if (this.props.previewSelectedFormId !== undefined) {
      this.props.formsTabChanged(activeIndex);
    }
    this.props.onFormChange(activeIndex);
    this.setState({ activeIndex });
  };

  render() {
    const panes = [];
    const { selectedFormIndex, newFormsData } = this.props;
    const activeIndex = !selectedFormIndex || selectedFormIndex > newFormsData.length - 1
      ? 0 : selectedFormIndex;
    const { acctTheme } = this.props;
    _.forEach(newFormsData, (formsData, index) => {
      const formId = formsData[0].FormId;

      const searchFormsData = this.props.searchFormsData;
      panes.push({
        menuItem:
          acctTheme === 0 ? (
            <Menu.Item
              key={`Tab_${formId}_${index}`}
              style={{
                fontSize: "12px",
                borderRadius: "10px 10px 0 0 !important",
              }}
              className={
                activeIndex === index
                  ? "classicTab form_header selected_background"
                  : "classicTab form_header form_tab_unselected"
              }
            >
              {acctTheme === 0 && activeIndex === index && <Icon name="star" />}
              {formsData[0].FormTitle}
            </Menu.Item>
          ) : (
            formsData[0].FormTitle
          ),
        render: () => (
          <Tab.Pane className="medium-font">
            <SearchFormTemplate
              key={`Form_${formId}_${index}`}
              formId={formId}
              formControls={formsData}
              {...this.props}
              defaultFormData={searchFormsData[`Form_${formId}`]}
            />
          </Tab.Pane>
        ),
      });
    });
    return (
      <Tab
        panes={panes}
        activeIndex={activeIndex}
        onTabChange={this.handleTabChange}
      />
    );
  }
}

export default SearchForms;



// WEBPACK FOOTER //
// ./src/components/searches/SearchForms.js